import { gsap } from "gsap";
const buttons = [...document.querySelectorAll(".button:has(svg)")];

buttons.forEach((button) => {
	
});
